import { Button } from '@/components/ui/lib/button';
import { cn } from '@/utils/cn';
import type { PrimaryButtonProps } from '@/components/ui/types/primary-button';

const PrimaryButton = ({ children, className, size = 'lg', ...rest }: PrimaryButtonProps) => {
  return (
    <Button
      size={size}
      bg="var(--chakra-colors-primary-500)"
      color="white"
      _hover={{ bg: 'var(--chakra-colors-primary-500)' }}
      _active={{ bg: 'var(--chakra-colors-primary-500)' }}
      className={cn(className)}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
